import "bootstrap/dist/css/bootstrap.min.css";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { saveAs } from 'file-saver';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import '../../DataTableDemo.css';
import ConfBar from '../ConfBar/ConfBar';
import Video from '../Video/Video';
import { Form, FormGroup, Forms, Label } from './HistoricPayroll.styles';
import useWindowDimensions from '../hooks/useDimensions';
import './HistoricPayroll.css'
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import { excelReport } from "../../services/excelReport.service";
import { excelExport } from "../../services/excelExport.service";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : HistoricPayroll
Description : Consulta de nómina de acumulados históricos,
Date Autor Modification
================================================================================
01/03/2022 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */


export default function HistoricPayroll() {

  /*Listas de valores del componente*/
  const [listaContrato, setListaContrato] = useState([]);
  const [listaConcepto, setListaConcepto] = useState([]);
  const [listaCalendario, setListaCalendario] = useState([]);

  /*Propiedades del componente*/
  const [calendario, setCalendario] = useState("");
  const [contrato, setContrato] = useState("");
  const [concepto, setConcepto] = useState("");
  const [ano, setAno] = useState("");
  const [mes, setMes] = useState("");
  const [consultado, setConsultado] = useState(false);
  const [consultado2, setConsultado2] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);

  const [rowId, setRowId] = useState(0);
  const [isOpen, setIsOpen] = React.useState(false);

  /*Constantes globales para el componente*/
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const { width } = useWindowDimensions()

  useEffect(() => {
    const getLists = async () => {
      /*Se cargan los datos de la listas de valores del componente*/
      await apis.getValueListHistoricPayroll(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
        //console.log(res.data)
        let contratos = res.data["DETAIL"][0]["DETAIL"]
        let calendarios = res.data["DETAIL"][1]["DETAIL"]
        let conceptos = res.data["DETAIL"][2]["DETAIL"]
        setListaContrato(contratos);
        setListaCalendario(calendarios);
        setListaConcepto(conceptos)
      })
    }
    getLists()
  }, [rowId]);

  /*Funciones que manejan el comportamiento de la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const renderHeader1 = () => {
    return (
      <div className="barra">
        <div className="barra2">
          <Button type="button" icon="pi pi-upload" label="Cargar acumulados" className="p-button-success mr-2" onClick={() => showModal()} />
          <Button type="button" disabled={!consultado2} icon="pi pi-file-excel" label="Exportar" loading={loading3} onClick={() => { setLoading3(true); exportExcel() }} className="p-button-success mr-2" data-pr-tooltip="XLS" />
          <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        </div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla del componente*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Filtro de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'Contrato': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Identificación': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Calendario': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Concepto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Nombre_concepto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Tipo_concepto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Base': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Valor': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Consolidado': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Unidades': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Unidades_consolidado': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  function handleSubmit(event) {
    event.preventDefault();
  }

  const showModal = () => {
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    //limpiar();
  };

  async function limpiar() {
    setCalendario("");
    setConcepto("");
    setContrato("");
    setAno("");
    setMes("");
    setConsultado(false)
  }

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _ano = ano
    const _mes = mes
    let _calendario = ""
    let _contrato = ""
    let _concepto = ""
    if (calendario !== "" && calendario !== undefined) {
      _calendario = calendario.CODE
    }
    if (contrato !== "" && contrato !== undefined) {
      _contrato = contrato.CODE
    }
    if (concepto !== "" && concepto !== undefined) {
      _concepto = concepto.CODE
    }

    const payroll = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CALENDAR: _calendario,
      CONTRACT: _contrato,
      CONCEPT: _concepto,
      YEAR: _ano,
      MONTH: _mes
    }

    try {
      await apis.postHistoricPayroll(payroll, headers).then(res => {
        if (res.data["PAYROLL_ACCUMULATED"].length > 0) {
          let data = res.data["PAYROLL_ACCUMULATED"]
          let newRows = []
          data.forEach(d => {
            newRows.push({
              "Contrato": d.CONTRACT,
              "Identificación": d.NUMBER_ID,
              "Nombre": d.NAME,
              "Calendario": d.CALENDAR,
              "Año": d.YEAR,
              "Mes": d.MONTH,
              "Concepto": d.CONCEPT,
              "Nombre_concepto": d.NAME_CONCEPT,
              "Tipo_concepto": d.TYPE_CONCEPT,
              "Unidades": d.UNITY,
              "Base": d.BASE,
              "Valor": d.REMUNER,
              "Consolidado": d.REMUNER_CSO,
              "Unidades_consolidado": d.UND_CSO,
            })
          })
          setRows(newRows)
          setRowData(newRows)
          setConsultado2(true)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Consulta exitosa' });
        }
        else {
          setRows([])
          setRowData([])
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Consulta sin resultados' });
        }
        setLoading1(false)
      })
    }
    catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function downloadSampleFile() {
    let payload = {
      NAME: "UploadAccumulated",
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.uploadHistoricPayroll(payload, headers).then(res => {
        sampleFile = res.data
        //console.log(sampleFile)
        excelReport(sampleFile, 'PlantillaCargueAcumulados')
        setLoading2(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: err.response.data.message, sticky: true });
      setLoading2(false)
    }
  }

  const exportExcel = () => {
    excelExport(rows, 'NóminaAcumuladosHistoricos')
    setLoading3(false)
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.uploadHistoricPayroll(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importHistoricPayroll(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0];

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadAccumulated",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  /*Funciones que dan formato de moneda a valores de este tipo en la tabla*/
  const formatCurrency = (value) => {
    let currency = parseInt(value)
    return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
  }

  const valueBodyTemplateBase = (rowData) => {
    if (rowData.Base) {
      return formatCurrency(rowData.Base);
    }
    else {
      return null;
    }
  }

  const valueBodyTemplateValor = (rowData) => {
    if (rowData.Valor) {
      return formatCurrency(rowData.Valor);
    }
    else {
      return null;
    }
  }

  const valueBodyTemplateConsolidado = (rowData) => {
    if (rowData.Consolidado) {
      return formatCurrency(rowData.Consolidado);
    }
    else {
      return null;
    }
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  /*Header y footers de los modales del componente*/
  const footer = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} onClick={() => { setLoading2(false); setLoading3(false); hideModal() }}>Cancelar</Button>
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading2} onClick={() => { setLoading2(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importHistoricPayroll}>
      </FileUpload>
    </div>
  );

  const header = (
    <div>
      <h3>Cargar acumulados</h3>
    </div>
  )

  /*Renderizado del componente*/
  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Nómina acumulados históricos</span>
          <Video header="Instructivo consultas" url={localStorage.getItem('HISTORICPAYROLL_VIDEO')} />
        </div>
        <div style={{ marginBottom: "2rem" }}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
        </div>
        <Dialog header={header} footer={footer} visible={isOpen}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
          <br />
          <span>2. Diligencie la hoja Modelo de Cargue, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
          <br />
          <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
        </Dialog>
        <Form onSubmit={handleSubmit}>
          <Forms>
            <div className="inputs flex flex-row justify-content-between align-items-end">
              <div className="inputs flex flex-row">
                <FormGroup className="flex flex-column">
                  <Label htmlFor="label">Calendario</Label>
                  <Dropdown value={calendario}
                    filter showClear filterBy="NAME" emptyMessage={"No hay calendarios disponibles"}
                    disabled={ano && mes || ano || mes}
                    style={{ width: "10rem" }}
                    options={listaCalendario} placeholder={"Seleccione calendario"}
                    onChange={(e) => setCalendario(e.value)}
                    optionLabel='NAME'
                  />
                </FormGroup >
                &nbsp;
                <FormGroup className="flex flex-column">
                  <Label htmlFor="label">Contrato</Label>
                  <Dropdown value={contrato}
                    filter showClear filterBy="NAME"
                    options={listaContrato} emptyMessage={"No hay empleados disponibles"}
                    onChange={(e) => setContrato(e.value)}
                    style={{ width: "10rem" }}
                    placeholder={"Seleccione un empleado"} optionLabel='NAME'
                  />
                </FormGroup>
                &nbsp;
                <FormGroup className="flex flex-column">
                  <Label htmlFor="label">Concepto</Label>
                  <Dropdown value={concepto}
                    filter showClear filterBy="NAME"
                    options={listaConcepto} emptyMessage={"No hay conceptos disponibles"}
                    onChange={(e) => setConcepto(e.value)}
                    style={{ width: "10rem" }}
                    placeholder={"Seleccione un concepto"} optionLabel='NAME'
                  />
                </FormGroup>
                &nbsp;
                <FormGroup className="flex flex-column">
                  {calendario || contrato ?
                    <Label htmlFor="label">Año</Label> :
                    <Label htmlFor="label">Año*</Label>}
                  <InputText
                    id="label7"
                    type="text"
                    maxLength={4}
                    disabled={calendario}
                    style={{ width: "5rem" }}
                    value={ano}
                    onChange={(e) => setAno(e.target.value)}
                  />
                </FormGroup>
                &nbsp;
                <FormGroup className="flex flex-column">
                  {calendario || contrato || ano ?
                    <Label htmlFor="label">Mes</Label> :
                    <Label htmlFor="label">Mes*</Label>}
                  <InputText
                    id="label7"
                    type="text"
                    maxLength={2}
                    disabled={calendario}
                    style={{ width: "4rem" }}
                    value={mes}
                    onChange={(e) => setMes(e.target.value)}
                  />
                </FormGroup>
              </div>
              <Button className="h-3rem mt-2" label="Consultar" loading={loading1} icon="pi pi-search" onClick={() => { setLoading1(true); setTabla() }} />
            </div>
          </Forms>
        </Form>
        <div className="card mt-4">
          <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
            selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
            size="small" filters={filters1} filterDisplay="menu"
            globalFilterFields={['Contrato', 'Identificación', 'Nombre', 'Calendario', 'Concepto', 'Nombre_concepto', 'Tipo_concepto', 'Base', 'Valor', 'Consolidado', 'Unidades', 'Unidades_consolidado']}
            header={header1} >
            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
            <Column field="Contrato" align="right" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
            <Column field="Identificación" align="right" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
            <Column field="Nombre" align="right" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
            <Column field="Calendario" align="right" header="Calendario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Calendario" sortable></Column>
            <Column field="Año" align="right" header="Año" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Año" sortable></Column>
            <Column field="Mes" align="right" header="Mes" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Mes" sortable></Column>
            <Column field="Concepto" align="right" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Concepto" sortable></Column>
            <Column field="Nombre_concepto" align="right" header="Nombre concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre concepto" sortable></Column>
            <Column field="Tipo_concepto" align="right" header="Tipo concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo concepto" sortable></Column>
            <Column field="Unidades" align="right" header="Unidades" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades" sortable></Column>
            <Column field="Base" align="right" header="Base" body={valueBodyTemplateBase} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Base" sortable></Column>
            <Column field="Valor" align="right" header="Valor" body={valueBodyTemplateValor} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Valor" sortable></Column>
            <Column field="Consolidado" align="right" header="Consolidado" body={valueBodyTemplateConsolidado} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Consolidado" sortable></Column>
            <Column field="Unidades_consolidado" align="right" header="Unidades consolidado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
          </DataTable>
        </div>
      </div>
    </div>
  );
}